export class MockConcessionService {
  getConcessions = jasmine.createSpy('getConcessions');
  getISOCountryByConcessionSlug = jasmine.createSpy('getISOCountryByConcessionSlug');
}
